import Axios from 'axios'

const token = localStorage.getItem('@token')
const baseUrl = process.env.REACT_APP_BASE_URL

const API = Axios.create({
    baseURL: baseUrl,
    timeout: 30000,
    headers: {
        "Accept": 'application/json',
        "Content-Type": 'application/json',
        "Authorization": `Bearer ${token}`
    }
})

API.interceptors.response.use(res => {
    return res
}, err => {

    // Disconnect on unauthenticated — skip on login attempt to allow error display
    if(err?.response?.status === 401 && !err?.config?.url?.includes('/auth')){
        localStorage.clear()
        window.location.href="/"
        setTimeout(() => {
            window.location.reload()
        }, 1000)
    }

    throw err

})

export default API